import { GeneralView } from "@/admin/settings/GeneralView.tsx";
import { createLazyFileRoute } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/admin/_menu/_simple/general")({
    component: GeneralView,
});
